import { Enums } from "../models/common/enums"

import { ConfigHelper } from "./config-helper"
import { Theme, ThemeHelper } from "./theme-helper"
import { IUserSession } from "./user-session"
import * as _ from 'underscore'

export type CustomStyle = {
    theme?: string
    iconSize?: Enums.SimaxIconSize
}

export class TemplateHelper {

    // Icons

    public static getIcon(icon: ConfigHelper.Icon, userSession: IUserSession = null, { theme, iconSize = Enums.SimaxIconSize.Normal }: CustomStyle = {}): string {
        const themeToUse: Theme = ThemeHelper.getTheme(userSession)
        const iconName: string = ConfigHelper.getIconName(icon)
        const themeObj: Theme = ConfigHelper.getValue(Enums.SimaxConfigSection.Themes, themeToUse ? themeToUse.name : theme)

        return '<ng-md-icon class="icon" icon="' + iconName + '" style="fill: ' + themeObj.fillColor + '" size="' + themeObj.iconSize[iconSize] + '"></ng-md-icon>'
    }

    public static getIconWithText(text: string, icon: ConfigHelper.Icon, userSession: IUserSession = null, customStyles: CustomStyle = {}): string {
        const iconTemplate: string = TemplateHelper.getIcon(icon, userSession, customStyles)

        return '<span class="icon-with-text">' + iconTemplate + '<span>' + text + '</span></span>'
    }

    public static getIconWithAdditionalIcon(mainIcon: ConfigHelper.Icon, secondIcon: ConfigHelper.Icon, userSession: IUserSession = null): string {
        const themeToUse: Theme = ThemeHelper.getTheme(userSession)
        const mainIconName: string = ConfigHelper.getIconName(mainIcon)
        const secondIconName: string = ConfigHelper.getIconName(secondIcon)
        const themeObj: Theme = ConfigHelper.getValue(Enums.SimaxConfigSection.Themes, themeToUse.name)
        
        return '<div style="display: flex; flex-direction: row; justify-content: center; align-items: center;"><ng-md-icon icon="' + mainIconName + '" style="fill: ' + themeObj.fillColor + '" size="' + themeObj.iconSize[Enums.SimaxIconSize.Normal] + '"></ng-md-icon><ng-md-icon icon="' + secondIconName + '" style="position: absolute; right: 2px; bottom: 2px; fill: ' + themeObj.fillColor + '" size="12"></ng-md-icon>' + '</div>'

    }

    // Icons End

    // Menu Items

    public static getContextMenuItem(text: string, icon: ConfigHelper.Icon, userSession: IUserSession = null, customStyles: CustomStyle = {}): string {
        const iconTemplate: string = TemplateHelper.getIconWithText(text, icon, userSession, customStyles)

        return '<div class="context-menu__item">' + iconTemplate + '</div>'
    }

    // Menu Items End

    public static getTextWidth(text: string, fontSize: string, fontFamily: string) {
        if (text == null || fontSize == null || fontFamily == null) {
            return 0
        }
        const element: HTMLCanvasElement = document.createElement('canvas')
        const elContex: CanvasRenderingContext2D = element.getContext('2d')
        elContex.font = '' + fontSize + ' ' + fontFamily + ''
        return elContex.measureText(text).width
    }    
}